import React, { useMemo, useState } from 'react';

import { APIEntityType } from '@cd3p/core/types/api';

import { AccessAproveRejectModal } from './AccessAproveRejectModal';

export type RequestedAccessEntity = {
  entityId?: string;
  entityType: string;
};

export const useSensitiveDataAccessDecision = () => {
  const [requestedAccessEntity, setRequestedAccessEntity] =
    useState<null | RequestedAccessEntity>(null);

  return useMemo(
    () => ({
      requestedAccessEntity,
      setRequestedAccessEntity,
      SensitiveDataAccessDecisionModal: () =>
        requestedAccessEntity ? (
          <AccessAproveRejectModal
            onClose={() => setRequestedAccessEntity(null)}
            requestedEntityId={requestedAccessEntity.entityId}
            requestedEntityType={
              requestedAccessEntity.entityType as APIEntityType
            }
          />
        ) : null,
    }),
    [requestedAccessEntity],
  );
};
